'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    setTimeout(function() {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });

    twentyninetimes.siteHeader.init();
    twentyninetimes.navigation.init();
    twentyninetimes.accordion.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.draggableContainers.init();
    twentyninetimes.sliders.init();
    twentyninetimes.anchorScroll.init();
    twentyninetimes.blockPricing.init();

    var scroll_item = document.querySelectorAll('.scroll-item');
    twentyninetimes.inView.init(scroll_item);

    twentyninetimes.integrations.init();

    var hubspot_triggers = document.querySelectorAll('.js-hubspot-trigger');
    if ( hubspot_triggers ) {
        hubspot_triggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                window.HubSpotConversations.widget.open();
            });
        });
    }
});


